import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ModalBase, { modalPropTypes } from './ModalBase'
import {
  ImageWrapper,
  Content,
  Wrapper,
  Slide,
  Footer,
  Dots,
  Dot,
  Actions
} from './ModalCarousel.styles'
import { CloseIcon } from 'components/lib/icons'
import { Button } from 'components/lib/buttons'
import Slider from 'react-slick'
import { colors } from 'config/ui'
import { Cdn } from 'utils/assets'

const BIG_SCREEN_WIDTH = 900

class ModalCarousel extends Component {
  static propTyes = {
    ...modalPropTypes,
    image: PropTypes.string,
    gradient: PropTypes.shape({
      top: PropTypes.string.isRequired,
      bottom: PropTypes.string.isRequired
    })
  }

  static defaultProps = {
    image: Cdn.getAssetUrl2('arvore2018/lla.png'),
    gradient: {
      top: '#363756',
      bottom: '#9b59b6'
    }
  }

  state = {
    activeSlide: 0,
    bigScreen: window.innerWidth >= BIG_SCREEN_WIDTH
  }

  prevSlide = () => {
    this.slider.slickPrev()
  }

  nextSlide = () => {
    this.slider.slickNext()
  }

  goToSlide = index => {
    this.slider.slickGoTo(index)
  }

  matchMedia = e => {
    this.setState({
      bigScreen: e.matches
    })
  }

  componentDidMount() {
    window
      .matchMedia(`(min-width: ${BIG_SCREEN_WIDTH}px)`)
      .addListener(this.matchMedia)
  }

  componentWillUnmount() {
    window
      .matchMedia(`(min-width: ${BIG_SCREEN_WIDTH}px)`)
      .removeListener(this.matchMedia)
  }

  render() {
    const { gradient, image, children, ...props } = this.props
    const { activeSlide, bigScreen } = this.state
    const childCount = React.Children.count(children)

    return (
      <ModalBase
        width={bigScreen ? `${BIG_SCREEN_WIDTH}px` : '300px'}
        {...props}
      >
        <Wrapper>
          {bigScreen && (
            <ImageWrapper gradient={gradient}>
              <img src={image} alt="" />
            </ImageWrapper>
          )}
          <Content bigScreen={bigScreen} gradient={gradient}>
            <CloseIcon
              onClick={props.onClose}
              color={bigScreen ? colors.black : colors.white}
            />
            <Slider
              ref={ref => {
                this.slider = ref
              }}
              infinite={false}
              dots={false}
              arrows={false}
              slidesToShow={1}
              afterChange={activeSlide => this.setState({ activeSlide })}
            >
              {React.Children.map(children, (child, index) => (
                <Slide key={index}>{child}</Slide>
              ))}
            </Slider>
          </Content>
        </Wrapper>
        {childCount > 1 && (
          <Footer>
            {bigScreen && (
              <Dots>
                {[...Array(childCount).keys()].map(key => (
                  <Dot
                    onClick={() => this.goToSlide(key)}
                    active={activeSlide === key}
                    key={key}
                  />
                ))}
              </Dots>
            )}
            <Actions>
              <Button
                disabled={activeSlide === 0}
                onClick={this.prevSlide}
                outline
              >
                Anterior
              </Button>
              <Button
                disabled={activeSlide === childCount - 1}
                onClick={this.nextSlide}
                outline
              >
                Próximo
              </Button>
            </Actions>
          </Footer>
        )}
      </ModalBase>
    )
  }
}

export default ModalCarousel
